/**
 *@format
 */
import { api } from '@/scripts/api';

export const AgencyManagementService = {
    getAll({ accountId, config }, signal) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/mdf/requests-partners/account/${accountId}`;
            let endpoint = api.applyNodeDataParams(service, config);
            let connectedAccountStatuses;
            if (config.connectedAccountStatuses && Array.isArray(config.connectedAccountStatuses)) {
                connectedAccountStatuses = JSON.stringify(config.connectedAccountStatuses);
            }
            api.ajax({
                url: endpoint,
                method: 'get',
                params: { connectedAccountStatuses },
                signal: signal,
            })
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },

    getAllIds({ accountId, config }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/mdf/requests-partners/account/${accountId}/ids`;
            const endpoint = api.applyNodeDataParams(service, config);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    exportCsv({ accountId, payload }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/mdf/requests-partners/account/${accountId}/export`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    getSummary({ accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/mdf/management/summary/account/${accountId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    returnToPending({ accountId, fundRequestId }) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}/pending-funds`;
            api.post(endpoint).then(resolve).catch(reject);
        });
    },

    assignMDFRequestManager({ accountId, fundRequestId, payload }) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/marketing-development-funds/v1/fund-requests-participants/vendor-account/${accountId}/requests/${fundRequestId}/managers`;
            api.post(endpoint, payload).then(resolve).catch(reject);
        });
    },

    assignMDFUserRequestApprover({ accountId, fundRequestId, payload }) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/marketing-development-funds/v1/fund-requests-participants/vendor-account/${accountId}/requests/${fundRequestId}/approvers`;
            api.post(endpoint, payload).then(resolve).catch(reject);
        });
    },

    assignMDFUserToPartner({ accountId, payload }) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/marketing-development-funds/v1/partner-managers/account/${accountId}/managers`;
            api.post(endpoint, payload).then(resolve).catch(reject);
        });
    },

    getAllocations({ accountId, config }, signal) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/mdf/allocations/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, config);
            api.get(endpoint, signal)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },
};
